'use client';

import { c as _c } from "react/compiler-runtime";
import { useRouter } from 'next/navigation';
import { Fragment, type PropsWithChildren } from 'react';

//* cacheComponents의 Activity 보존 때문에 재진입한 폼이 이전 입력을 물려받지 않게 한다 — 뒤로가기는 bfcacheId가 같아 유지된다
export const ResetOnNavigation = t0 => {
  const $ = _c(3);
  const {
    children
  } = t0;
  const {
    bfcacheId
  } = useRouter();
  let t1;
  if ($[0] !== bfcacheId || $[1] !== children) {
    t1 = <Fragment key={bfcacheId}>{children}</Fragment>;
    $[0] = bfcacheId;
    $[1] = children;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  return t1;
};